import camelCase from 'lodash/camelCase';
import snakeCase from 'lodash/snakeCase';
import config from './config.json';
// Initialize window.services before loading any remotes
window.services = {};

const isAcceptance = (process.env.REACT_APP_GUILD_BASE_URL || '').includes('guildacceptance.com');

config.services.forEach(({ subdomain }) => {
  const hostIsLocal = process.env.NODE_ENV === 'development';

  const envSubdomain = isAcceptance
    ? hostIsLocal
      ? `${subdomain}-dev`
      : `${subdomain}-staging`
    : subdomain;
  const NAME = snakeCase(subdomain).toUpperCase().replace(/\./, '_');
  const envKey = `REACT_APP_${NAME}_URL`;
  const defaultUrl = `https://${envSubdomain}.${process.env.REACT_APP_GUILD_BASE_URL}`;

  window.services[camelCase(subdomain)] = process.env[envKey] || defaultUrl;
});

// Load the app after services are initialized
import(/* webpackChunkName: "host" */ './index').catch(err => {
  // Surface the error visibly — in production, unhandled dynamic import
  // failures result in a blank page with no indication of what went wrong.
  // eslint-disable-next-line no-console
  console.error('[platform] Failed to load app:', err);
  const root = document.getElementById('root');
  if (root) {
    const message = err instanceof Error ? `${err.message}\n\n${err.stack}` : String(err);
    const pre = document.createElement('pre');
    pre.style.cssText = 'padding:2rem;font-family:monospace;white-space:pre-wrap';
    const heading = document.createElement('h2');
    heading.textContent = 'Platform failed to load';
    pre.appendChild(heading);
    pre.appendChild(document.createTextNode(message));
    root.appendChild(pre);
  }
});
